import { ImageEdit } from '@powerportalspro/react-fluent';

export function ImageEditMainSample() {
  return <ImageEdit columnName="ppp_primaryimage" />;
}
